import React, { createContext, useContext, useState, useEffect } from "react";
import { Schedule } from "../types/schedule.types";
import { getSchedules } from "../services/scheduleService";
import { useUserContext } from "./UserContext";
import { useOrderContext } from "./OrderContext";
import { log } from "../utils/logger";

interface ScheduleContextType {
    schedule: Schedule | null;
    fetchSchedule: ()=>void
}


const ScheduleContext = createContext<ScheduleContextType | undefined>(undefined);


export const ScheduleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [schedule, setSchedule] = useState<Schedule | null>(null);
    const { userData, loggedIn } = useUserContext();
    const { orderData } = useOrderContext();
    
    
    const fetchSchedule = async () => {
        const cached = localStorage.getItem("catermat_schedule");
        const cachedDate = localStorage.getItem("catermat_scheduleFetchedAt");
        const today = new Date().toDateString();

        if (cached && cachedDate === today) {
            // Already have today’s data
            setSchedule(JSON.parse(cached));
            return;
        }

        getSchedules().then((response)=>{
            const data = response.data
            setSchedule(data);
            localStorage.setItem("catermat_schedule", JSON.stringify(data));
            localStorage.setItem("catermat_scheduleFetchedAt", today);
        })

    };
    useEffect(() => {
        fetchSchedule();
    }, [loggedIn]);


    return (
        <ScheduleContext.Provider value={{schedule, fetchSchedule}}>
        {children}
        </ScheduleContext.Provider>
    );
};

export const useSchedule = () => {
    const context = useContext(ScheduleContext);
    if (!context) throw new Error("useSchedule must be used within a ScheduleProvider");
    return context;
};
